export default __webpack_public_path__ + "static/media/img_6.e1ea3507.JPG";